import { getConfigWithMetadata, hasAuthorization } from '@pkgs/api/utils/headers';
import { getErrorResult } from '@pkgs/api/utils/error';
import { type ApiConfig, type ApiResult } from '@pkgs/api/types';
import { type EditSearchAlertRequest } from '@pkgs/api/models';
import {
  editSearchAlert as generatedEditSearchAlert,
  type EditSearchAlertResult as GeneratedEditSearchAlertResult,
} from '@generated/search-bff/controllers/search-alert/search-alert';

/**
 * Edit a search alert using the `/api/v4/searchalert/alert/{searchAlertId}` endpoint.
 * Requires a valid JWT token in the `apiConfig`.
 * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/searchAlerts/editSearchAlert Search API Documentation}
 */
export async function editSearchAlert(
  searchAlertId: string,
  editSearchAlertRequest: EditSearchAlertRequest,
  apiConfig: ApiConfig,
): Promise<ApiResult<void>> {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, 'editSearchAlert');

    if (!hasAuthorization(_apiConfig)) {
      console.warn(
        'JWT token is required. Please provide a valid JWT token in the `apiConfig` via `jwtToken` or `headers.Authorization` or provide a `getToken` function in the `apiConfig`',
      );
    }

    await generatedEditSearchAlert(searchAlertId, editSearchAlertRequest, _apiConfig);
    return { status: 'success', data: undefined };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}

export type EditSearchAlertResult = GeneratedEditSearchAlertResult;
